import type { InvariantJiraRoute } from '@atlassian/jira-route-types/src/InvariantJiraRoute.tsx';

export const globalSettingsProductsJsdStatusRoute: InvariantJiraRoute = {
	name: 'global-settings-products-jsd-status',
	path: '/plugins/servlet/ac/jsd-status-page',
};
